// extracted by extract-css-chunks-webpack-plugin
module.exports = {"suggestionHighlighted":"_12S6Zf","suggestionsContainerOpen":"twrt9k","container":"_2vjq_a","suggestionsContainer":"_3Qo-67","suggestion":"_30jwMJ"};